module.exports = __webpack_public_path__ + "media/site_templates/www.bathroomrenovations.biz/images/testimonials-849ea527b1ab6eba12aae19a149779fb.jpg";